const lineHeight = [1, 1.2, 1.5, 1.7, 2]

export default lineHeight



// WEBPACK FOOTER //
// ./src/constants/toolbarEditorOptions/lineHeight.js